import styled from "styled-components";

export const MainDiv = styled.div`
  margin-bottom: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
